import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Divider
} from "@mui/material";
import { BarChart, TableRows } from "@mui/icons-material";
import ProductMetrics from "./ProductMetrics";
import CompetitorChart from "./CompetitorChart";
import CompetitorTable from "./CompetitorTable";

export default function ProductReferenceDetails({ productData, isLoading }) {
  const [viewMode, setViewMode] = useState('chart');

  if (!productData && !isLoading) {
    return (
      <Box sx={{ 
        textAlign: 'center', 
        py: 8,
        color: '#64748b'
      }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Selecione um produto
        </Typography>
        <Typography variant="body2">
          Escolha um produto da lista acima para ver os detalhes das referências de preço
        </Typography>
      </Box>
    );
  }

  if (isLoading) {
    return (
      <Box sx={{ 
        textAlign: 'center', 
        py: 8,
        color: '#64748b'
      }}>
        <Typography variant="body1">
          Carregando detalhes do produto...
        </Typography>
      </Box>
    );
  }

  return (
    <Card sx={{ 
      boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04)',
      borderRadius: '16px',
      border: '1px solid rgba(0,0,0,0.06)',
      backgroundColor: '#ffffff'
    }}>
      <CardContent sx={{ p: { xs: 3, md: 4 } }}>
        {/* Header do produto */}
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          mb: 4,
          flexWrap: 'wrap',
          gap: 3
        }}>
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                color: '#1a1a1a',
                mb: 0.5,
                fontSize: '1.15rem'
              }}
            >
              {productData.product_title}
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#64748b',
                fontSize: '0.875rem',
                fontFamily: 'monospace'
              }}
            >
              ID: {productData.item_id}
            </Typography>
            {productData.last_updated && (
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#64748b',
                  fontSize: '0.8rem',
                  mt: 0.5
                }}
              >
                Última atualização: {productData.last_updated}
              </Typography>
            )}
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1,
              p: 1.5,
              borderRadius: '8px',
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0'
            }}>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.8rem' }}>
                Competidores analisados: {productData.competitors_count || 0}
              </Typography>
            </Box>
            
            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(_, newMode) => newMode && setViewMode(newMode)}
              size="small"
              sx={{
                backgroundColor: '#f8fafc',
                borderRadius: '10px',
                padding: '2px',
                '& .MuiToggleButton-root': {
                  border: 'none',
                  borderRadius: '8px',
                  px: 2.5,
                  py: 0.75,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  textTransform: 'none',
                  color: '#64748b',
                  '&.Mui-selected': {
                    backgroundColor: '#ff7043',
                    color: 'white',
                    boxShadow: '0 1px 3px rgba(255, 112, 67, 0.3)',
                    '&:hover': {
                      backgroundColor: '#e64a19'
                    }
                  },
                  '&:hover': {
                    backgroundColor: '#e2e8f0'
                  }
                }
              }}
            >
              <ToggleButton value="chart">
                <BarChart sx={{ mr: 1, fontSize: 18 }} />
                Gráfico
              </ToggleButton>
              <ToggleButton value="table">
                <TableRows sx={{ mr: 1, fontSize: 18 }} />
                Tabela
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>

        {/* Métricas do produto */}
        <ProductMetrics productData={productData} />

        <Divider sx={{ my: 4 }} />

        {/* Visualização dos competidores */}
        {viewMode === 'chart' ? (
          <CompetitorChart productData={productData} />
        ) : (
          <CompetitorTable productData={productData} />
        )}
      </CardContent>
    </Card>
  );
}